import React from 'react';
import Modal from './Modal';
import Button from './Button';

// Modal especializado em confirmar ações destrutivas/importantes.
// Substitui window.confirm e os ConfirmDelete ad-hoc espalhados no app.
const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Tem certeza?',
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
  loading = false,
  children,
}) => {
  const handleConfirm = async () => {
    try {
      await onConfirm?.();
    } catch {
      /* caller trata o erro via toast / state próprio */
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      closeOnOverlayClick={!loading}
      footer={
        <>
          <Button variant="subtle" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={handleConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {message && <p className="text-app-text-secondary">{message}</p>}
      {children}
    </Modal>
  );
};

export default ConfirmDialog;
